import Resource from '@/api/core/resource' 

class Audits extends Resource {
  constructor () {
    super('Audit')
  }
  getUserAudits(listRequest){
    return this.request.post(this.uri.concat('/ListUserAudit'),listRequest)
  }
  getDocumentAudit(listRequest){
    return this.request.post(this.uri.concat('/ListDocumentAudit'),listRequest)
  }
}
export default new Audits()
